module.exports = __webpack_public_path__ + "static/media/phone5d4bd60069be21bc8f1650bc84f57f10.webp";